import React, { useState } from "react";
import PermissionsSubTabs from "./PermissionsSubTabs";
import PermissionsTable from "./PermissionsTable";
import SaveCancelButtons from "../SaveCancelButtons";
import { ErrorState } from "../ErrorState";
import UnsavedChangesModal from "../UnsavedChangesModal";

const PermissionsManagement = ({
  selectedGroup,
  permissionsHookResult,
  isToolbarSaving = false,
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);

  const {
    activeSubTab,
    formsContentType,
    permissions,
    loading,
    saving,
    hasChanges,
    error,
    handleSubTabChange,
    setFormsContentType,
    handlePermissionChange,
    handleSave,
    handleCancel,
    clearError,
    isPermissionDisabled,
  } = permissionsHookResult;

  const handleCancelClick = () => {
    if (hasChanges) {
      setShowCancelModal(true);
    } else {
      handleCancel();
    }
  };

  const handleModalCancel = () => {
    // User clicked "Cancel" (right button) - just close the modal
    setShowCancelModal(false);
  };

  const handleModalDiscard = () => {
    // User clicked "Discard" (left button) - discard changes
    handleCancel();
    setShowCancelModal(false);
  };

  const handleButtonSave = async () => {
    // Pass 'button' to indicate this is from bottom button
    await handleSave("button");
  };

  // Show loading state immediately when no group is selected
  if (!selectedGroup) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="text-customBlue text-lg font-semibold">
            No group selected
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full pt-4">
      {error && <ErrorState error={error} onClearError={clearError} />}

      <div className="px-4">
        <PermissionsSubTabs
          activeSubTab={activeSubTab}
          setActiveSubTab={handleSubTabChange}
        />
      </div>

      <div className="flex-1 px-4 pt-3 pb-6 min-h-0">
        <div className="h-full flex flex-col">
          <div className="flex-1 min-h-0">
            <PermissionsTable
              key={`${activeSubTab}-${formsContentType}`}
              permissions={permissions}
              loading={loading}
              onPermissionChange={handlePermissionChange}
              activeSubTab={activeSubTab}
              formsContentType={formsContentType}
              setFormsContentType={setFormsContentType}
              isPermissionDisabled={isPermissionDisabled}
            />
          </div>

          <SaveCancelButtons
            onSave={handleButtonSave}
            onCancel={handleCancelClick}
            isSaving={saving && !isToolbarSaving} // Only show loading for button saves
            disabled={!hasChanges || isToolbarSaving} // Disable when no changes OR when toolbar is saving
          />
        </div>
      </div>

      <UnsavedChangesModal
        show={showCancelModal}
        onHide={handleModalCancel}
        onLeftAction={handleModalDiscard}
        onRightAction={handleModalCancel}
        message="You have unsaved changes. Are you sure you want to discard them?"
        leftLabel="Discard"
        rightLabel="Cancel"
      />
    </div>
  );
};

export default PermissionsManagement;
